import React from "react";
import { Link } from "react-router-dom";
import { tutors } from "../../constants";

const OnlineTutor = () => {
  return (
    <div>
      {" "}
      <div className="my-3 ml-5">
        <Link to="/">Home</Link> / Online Tutor
        <h1 className="text-center text-4xl pb-2 font-bold">Online Tutor </h1>
        <p className="text-center text-lg text-gray-600 mb-8">
          <span className="text-blue-950 font-bold">Discover</span> online
          tutors ready to help you master your favorite musical instruments.
        </p>
      </div>
      <div className=" grid grid-cols-2">
        {tutors.map((tutor) => (
          <div
            key={tutor.id}
            class="mx-auto my-5 flex max-w-xs flex-col items-center rounded-xl border px-3 py-3 text-center md:max-w-lg md:flex-row md:items-start md:text-left"
          >
            <div class="mb-4 md:mr-6 md:mb-0">
              <img
                class="h-56 rounded-lg object-cover md:w-56"
                src={tutor.imageUrl}
                alt=""
              />
            </div>
            <div class="">
              <p class="text-xl font-medium text-gray-700">{tutor.name}</p>
              <p class="mb-4 text-sm font-medium text-gray-500">{tutor.role}</p>
              <div class="flex space-x-2">
                <div class="flex flex-col items-center rounded-xl bg-gray-100 px-4 py-2">
                  <p class="text-sm font-medium text-gray-500">Lessons</p>
                  <p class="text-3xl font-medium text-gray-600">
                    {tutor.lessons}
                  </p>
                </div>
                <div class="flex flex-col items-center rounded-xl bg-gray-100 px-4 py-2">
                  <p class="text-sm font-medium text-gray-500">Students</p>
                  <p class="text-3xl font-medium text-gray-600">
                    {tutor.students}
                  </p>
                </div>
                <div class="flex flex-col items-center rounded-xl bg-gray-100 px-4 py-2">
                  <p class="text-sm font-medium text-gray-500">Experience</p>
                  <p class="text-3xl font-medium text-gray-600">
                    {tutor.experience}
                  </p>
                </div>
                <div class=""></div>
              </div>
              <div class="mb-3"></div>
              <div class="flex space-x-2">
                <button class="w-full rounded-lg border-2 bg-white px-4 py-2 font-medium text-gray-500">
                  Message
                </button>
                <Link
                  to={`/videoCall/${tutor.id}`}
                  class="w-full rounded-lg border-2 border-transparent bg-blue-950 hover:bg-blue-900 pl-9 pr-4 py-2 font-medium text-white"
                >
                  Video call
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OnlineTutor;
